import VendorIcon from "./VendorIcon";

export default VendorIcon;
